export default {
    intro: 'Hãy nghe và viết chính xác nhé!',
    introHandwriting: 'Hãy nghe và tự tay viết chữ một cách chính xác nhé!',
    wordIndex: 'Từ thứ {index}',
    common: {
        handwritingView: 'Xem chữ viết tay',
    },
    student: {
        myAnswer: 'Đáp án tôi đã nộp',
        noAnswer: 'Chưa có đáp án nào được nộp.',
        answer: 'Đáp án',
        attemptNumber: 'Lần {number}',
        listen: 'Hãy lắng nghe nhé!<br />Hãy tập trung nghe!',
        teacherReading: 'Giáo viên đang đọc trực tiếp',
        listenDirect: 'Hãy lắng nghe câu mà Giáo viên đang đọc trực tiếp nhé!',
        placeholder: 'Hãy nhập đáp án.',
        wrongToast: 'Ồ, sai rồi. Hãy nhập lại nhé',
        writeEnd: 'Kết thúc viết',
        submitAnswer: 'Nộp đáp án',
        replay: 'Nghe lại',
        handwritingPad: {
            progressPrev: 'Cuộn thanh tiến trình sang trái',
            progressNext: 'Cuộn thanh tiến trình sang phải',
            cellNav: 'Đến ô số {index}',
            bigWriting: 'Viết lớn',
            eraseCell: 'Xóa ô',
            scrollLeft: 'Cuộn sang trái',
            scrollRight: 'Cuộn sang phải',
            submit: 'Nộp đáp án',
            tools: {
                pen: 'Bút',
                eraser: 'Tẩy',
                clear: 'Xóa tất cả',
            },
        },
        waitingStart: 'Hãy chờ tín hiệu bắt đầu viết của Giáo viên!',
        threeWrong: 'Bạn đã sử dụng hết 3 cơ hội trả lời... Hãy chờ Giáo viên công bố đáp án nhé!',
    },
    teacher: {
        setting: {
            activity: 'Nội dung hoạt động',
            number: 'Số thứ tự',
            title: 'Chính tả 📝',
            message: 'Nếu phát câu này, Học sinh cũng có thể nghe thấy!',
            subMessage: 'Vẫn muốn phát không?',
            optionSubMessage: 'Sau khi phát một lần, cửa sổ xác nhận sẽ không xuất hiện nữa.',
            confirmText: 'Phát',
            addQuestion: {
                button: 'Thêm câu hỏi',
                title: 'Thêm câu hỏi chính tả',
                guide: 'Bạn có thể dán văn bản đã sao chép từ bên ngoài. Mỗi dòng nhập một câu hỏi.',
                notice: '※ Xuống dòng để tách câu hỏi. 2 khoảng trắng liên tiếp trở lên được coi là dấu cách.',
                columnQuestion: 'Câu hỏi cần thêm',
                cancelConfirm: {
                    title: 'Xóa câu hỏi đã nhập?',
                    body: 'Nếu hủy, các câu hỏi đã nhập sẽ không được thêm và bị xóa hết.\nBạn có muốn tiếp tục không?',
                },
                deleteConfirm: {
                    title: 'Xóa câu hỏi này?',
                    body: 'Nếu xóa, câu hỏi đã thêm sẽ bị loại khỏi danh sách.\nBạn có muốn tiếp tục không?',
                },
                registering: 'Đang thêm câu hỏi...',
                noticeTitle: 'Thông báo',
                emptyData: 'Vui lòng nhập ít nhất một câu hỏi.',
                partialFail: '{count} câu hỏi không thể thêm do tạo TTS thất bại.',
                duplicateSkip: '{count} câu hỏi không được thêm vì đã tồn tại.',
                addFail: 'Thêm câu hỏi thất bại.',
                deleteFail: 'Xóa câu hỏi thất bại.',
                ttsSuccess: 'Đã tạo TTS.',
                ttsFail: 'Tạo TTS thất bại.',
            },
            inputMode: 'Phương thức nhập đáp án',
            inputModeKeyboard: 'Bàn phím',
            inputModeHandwriting: 'Viết tay',
            tracing: 'Viết theo',
            allowReplay: 'Cho phép học sinh nghe lại',
            allowReplayDesc: '*Khuyến nghị sử dụng khi lớp học được trang bị tai nghe.',
            previewGuide: 'Nhấn để nghe thử!',
            generateTts: 'Tạo TTS',
        },
        handwritingModal: {
            title: 'Chữ viết tay đáp án của học sinh',
            answer: 'Đáp án đúng',
            notAttempted: 'Chưa thử',
        },
        question: 'Câu hỏi',
        intro: 'Vui lòng chọn từ trong câu hỏi bên trái.',
        ttsStart: 'Phát rồi bắt đầu viết',
        directReading: 'Đọc trực tiếp',
        startWriting: 'Bắt đầu viết',
        completeWriting: 'Hoàn thành viết và công bố đáp án',
        viewStudentResult: 'Xem kết quả toàn bộ học sinh',
        toast: {
            alreadyDone: 'Đây là từ đã được thực hiện.',
            fiveSeconds: 'Có thể hoàn thành viết sau 5 giây kể từ khi bắt đầu viết.',
        },
        result: {
            title: 'Độ chính xác theo câu hỏi',
            order: 'Thứ tự',
            question: 'Câu hỏi',
            answerRate: 'Độ chính xác',
        },
    },
    table: { question: 'Câu hỏi', answerRate: 'Độ chính xác', emptyMessage: 'Không có nội dung.' },
};
